import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { FleetGenericFilter } from '../../Elements'
import { Grid, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip, Divider, Button, Paper, TextField, Tabs, Tab, Switch, FormLabel, FormControl, Checkbox } from '@material-ui/core';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import { TableListComp, PageLoader, ExportManu, EmptyCollection, FilterComponent } from '../../../shared_elements';
import { STableLoader } from '../../../shared_elements/loaders';
import { Switcher, FleetInvoice, InvoiceTypeGraph, InvoiceStatusGraph, InvoiceLesseeGraph, InvoiceLesseeTypeGraph } from '../components';
import { getPlatformConstantsLeaseStatusAc } from '../../../shared_elements/actionCreators';
import { getFleetInvoicesApi, exportFleetInvoicesApi, getInvoiceTypeGraphApi, geInvoiceStatusGraphApi, getLesseeTypeGraphApi, getInvoiceLesseeGraphApi, getAssetIdentifierApi, bulkInvoiceUpdateApi, generateSumInvoiceApi, getApplicableSummaryList, getBankList, bulkDownload } from '../apiServices';
import { globalFilterTypes, invoiceFleetFilterOps, invoiceStatus, invoiceType, invoiceFleetHd, jacInvoiceFleetHd, invoiceFilter } from '../'
import { convertFilterObject, removeEmptyKey, getLocalStorageInfo, checkPermission, checkApiStatus, toastFlashMessage } from '../../../utils_v2';
import { trackActivity } from '../../../utils/mixpanel';
import DeploymentMessage from '../../../shared_elements/components/DeploymentMessage';
import RoleBasedAccess from '../../../utils/RoleBasedAccess';
import { getLesseeFilterApi } from '../../Leases/apiServices';
import { Autocomplete } from '@material-ui/lab';
import { globalPostService, globalPutService } from '../../../globalServices';
import SummaryInvoice from '../components/SummaryInvoice';
import { browserHistory } from 'react-router';
import { globalGetService } from '../../../utils_v2/globalApiServices';
import InfoIcon from '@material-ui/icons/Info';
import { hanwahaInstance, titanInstance } from '../../../shared_elements/components';
import BulkStatusChangesDialog from '../components/BulkStatusChangeDialog';
import { jetStreamInstance } from '../../Leases';
import { getThirdPartyAppUrl } from '../../../applications/contracts/Invoice/apiServices';
class FleetInvoices extends Component {
  constructor(props){
    super(props);
    this.state = {
      skeletonLoader:false,
      skeletonLoaderInvType:false,
      skeletonLoaderInvStat: false,
      skeletonLoaderLesseeType: false,
      skeletonLoaderInvLessee: false,
      pageLoader:false,
      open:false,
      invoices:{ list:[], pagination:{} },
      sort: '',
      sort_by: '',
      filter: {},
      genericFilter:{},
      filterInvoiceType:{},
      filterInvoiceStatus:{},
      filterLesseeType:{},
      filterInvLessee:{},
      mode:'list',
      invoiceTypeGraph:{},
      invoiceStatGraph:{},
      invoiceLesseeTypeGraphData:{},
      invoicelesseeGraphData:{},
      assetTypeOptions:[],
      assetModelOptions:[],
      assetsOptions:[],
      lesseeOptions:[],
      lessorOptions:[],
      ownerOptions:[],
      lesseeFilter:[],
      bulkIds:[],
      bulkInvoiceStatus:{label:'Draft',value:'1'},
      tabIndex:this.props.location?.search.includes('summary_invoice')?'2': "1",
      fleetInvoiceState:1,
      syncDialogOpen: false,
      individualInvoice: false,
      bankList:[],
      bulkStatusUpdate:{ids:[],bulkStatus:[1,2],statusModal:false},
      invoiceApprovalStatus:false,
      pageSelections: {},
      currentPage: 1,
    };
    this.getFleetInvoicesApi = getFleetInvoicesApi.bind(this);
    this.exportFleetInvoicesApi = exportFleetInvoicesApi.bind(this);
    this.getInvoiceTypeGraphApi = getInvoiceTypeGraphApi.bind(this);
    this.geInvoiceStatusGraphApi = geInvoiceStatusGraphApi.bind(this);
    this.getLesseeTypeGraphApi = getLesseeTypeGraphApi.bind(this);
    this.getInvoiceLesseeGraphApi = getInvoiceLesseeGraphApi.bind(this);
    this.getAssetIdentifierApi = getAssetIdentifierApi.bind(this);
    this.getLesseeFilterApi = getLesseeFilterApi.bind(this);
    this.bulkInvoiceUpdateApi = bulkInvoiceUpdateApi.bind(this);
    this.generateSumInvoiceApi = generateSumInvoiceApi.bind(this);
    this.getApplicableSummaryList = getApplicableSummaryList.bind(this);
    this.getBankList = getBankList.bind(this);
    this.bulkDownload = bulkDownload.bind(this);
    this.getThirdPartyAppUrl = getThirdPartyAppUrl.bind(this);
  }
  componentDidMount(){
    const { genericFilter, filterInvoiceType, filterInvoiceStatus, filterLesseeType, filterInvLessee } = this.state;
    this.getFleetInvoicesApi(this.props, {per_page:50}, 'skeletonLoader');
    this.props.getPlatformConstantsLeaseStatus();
    this.getInvoiceTypeGraphApi(this.props, genericFilter, filterInvoiceType, 'skeletonLoaderInvType');
    this.geInvoiceStatusGraphApi(this.props, genericFilter, filterInvoiceStatus, 'skeletonLoaderInvStat');
    this.getLesseeTypeGraphApi(this.props, genericFilter, filterLesseeType, 'skeletonLoaderLesseeType');
    this.getInvoiceLesseeGraphApi(this.props, genericFilter, filterInvLessee, 'skeletonLoaderInvLessee');
    globalFilterTypes.map((item) => 
      this.getAssetIdentifierApi(item.label, item.type)
    )
    trackActivity('Lease Management',{
      event_type: 'Page Visited',
      page_title: 'Fleet Invoices List'
    });
    this.getLesseeFilterApi()
    this.getBankList()
  }

  createSortHandler = (sortField) => {
    const { sort, sort_by, filter } = this.state;
    this.setState({
      sort: sortField,
      sort_by: (sortField === sort ? sort_by === 'asc' ? 'desc' : 'asc' : 'asc')
    });
    if (sortField === sort) {
      if (sort_by === 'asc') {
        this.getFleetInvoicesApi(this.props, { ...filter, sort: sortField, sort_by: 'desc', per_page:50 }, 'pageLoader');
      } else {
        this.getFleetInvoicesApi(this.props, { ...filter, sort: sortField, sort_by: 'asc', per_page:50 }, 'pageLoader');
      }
    } else {
      this.getFleetInvoicesApi(this.props, { ...filter, sort: sortField, sort_by: 'asc', per_page:50 }, 'pageLoader');
    }
  }
  changeGenericFilter = (e, keyParam, value) => {
    let query = Object.assign({},this.state.genericFilter);
    if(value){
      query = {
        ...query,
        [keyParam]:value.id
      }
    }else{
      delete query[keyParam];
    }
    this.setState({genericFilter: query});
    this.applyGenericFilter(query);
  }

  applyGenericFilter = (genericFilter) => {
    const { filterInvoiceType, filterInvoiceStatus, filterLesseeType, filterInvLessee } = this.state;
    this.getInvoiceTypeGraphApi(this.props, genericFilter, filterInvoiceType, 'skeletonLoaderInvType');
    this.geInvoiceStatusGraphApi(this.props, genericFilter, filterInvoiceStatus, 'skeletonLoaderInvStat');
    this.getLesseeTypeGraphApi(this.props, genericFilter, filterLesseeType, 'skeletonLoaderLesseeType');
    this.getInvoiceLesseeGraphApi(this.props, genericFilter, filterInvLessee, 'skeletonLoaderInvLessee');
  }
  onClickDataPointFn = (data, category, type) => {
    const { lesseeOptions, filterInvoiceType, filterInvoiceStatus, filterLesseeType, filterInvLessee, genericFilter, sort, sort_by } = this.state;
    if(type == 'basedOnType') {
      this.getFleetInvoicesApi(this.props, { ...filterInvoiceStatus, ...genericFilter,  per_page:50, sort: sort, sort_by: sort_by, invoice_type:invoiceType.find(item => item.label === data).value}, 'pageLoader', 'underlyingData');
    }
    if (type == 'basedOnStatus') {
      this.getFleetInvoicesApi(this.props, { ...filterInvoiceType, ...genericFilter,  per_page:50, sort: sort, sort_by: sort_by, invoice_status:invoiceStatus.find(item => item.label === data).value}, 'pageLoader', 'underlyingData');
    }
    if (type == 'basedOnStatusLessee') {
      this.getFleetInvoicesApi(this.props, { ...filterInvLessee, ...genericFilter,  per_page:50, sort: sort, sort_by: sort_by, invoice_status:invoiceStatus.find(item => item.label === data).value , lessee_id:lesseeOptions.find(item => item.name === category).id}, 'pageLoader', 'underlyingData');
    }
    if (type == 'basedOnTypeLessee') {
      this.getFleetInvoicesApi(this.props, { ...filterLesseeType, ...genericFilter,  per_page:50, sort: sort, sort_by: sort_by, invoice_type:invoiceType.find(item => item.label === data).value, lessee_id:lesseeOptions.find(item => item.name === category).id}, 'pageLoader', 'underlyingData');
    }
  }
onBulkSelect = (item, flag)=>{
  if(flag){
    let ids = [...this.state.bulkIds, item]
    this.setState({bulkIds:ids})
  }
  else{
    this.setState({bulkIds:this.state.bulkIds.filter(id => id != item)})
  }
}
  onInvoiceBulkSelect = (item, flag, type) => {
    const filterStatus = this.state.filter?.invoice_status && [1, 2].includes(Number(this.state.filter?.invoice_status)) ? [Number(this.state.filter?.invoice_status)] : [1, 2];
    if (type === 'bulk') {
      if (flag) {
        let ids = item?.filter(optionItem => optionItem?.invoice_status?.value === this.state.bulkStatusUpdate?.bulkStatus[0])
        this.setState({ bulkStatusUpdate: { ...this.state.bulkStatusUpdate, ids: ids } })
      }
      else this.setState({ bulkStatusUpdate: { ...this.state.bulkStatusUpdate, ids: [], bulkStatus: filterStatus } })
    }
    else {
      if (flag) {
        let ids = [...this.state.bulkStatusUpdate?.ids, item]
        this.setState({ bulkStatusUpdate: { ...this.state.bulkStatusUpdate, ids: ids, bulkStatus: [item?.invoice_status?.value] } })
      }
      else {
        let ids = this.state.bulkStatusUpdate?.ids?.filter(optionItem => optionItem.id !== item?.id)
        if (ids.length === 0) this.setState({ bulkStatusUpdate: { ...this.state.bulkStatusUpdate, ids: [], bulkStatus: filterStatus } })
        else this.setState({ bulkStatusUpdate: { ...this.state.bulkStatusUpdate, ids: ids } })
      }
    }
  }

onBulkInvoiceStatus =(value)=>{
  this.setState({bulkInvoiceStatus:value})
  this.bulkInvoiceUpdateApi(this.state.bulkIds, this.props)
}
onChangetabs=(newValue)=>{
  if(newValue == 1){
    browserHistory.push('/invoices'); this.setState({tabIndex:newValue})
  }
  else{
    browserHistory.push('/invoices/?summary_invoice'); this.setState({tabIndex:newValue})
  }
}
getThirdPartyApp = (sync) => {
  localStorage.setItem('thirdPartyState', sync);
  this.setState({pageLoader:true});
  globalGetService(`contracts/app-plugin/quickbooks/authenticate/`)
    .then(response => {
      if (checkApiStatus(response)) {
        window.open(response.data.data.url, '_blank');
        this.setState({pageLoader:false});
      }
    })
    .catch(() => {
      // enqueueSnackbar('Error syncing with QuickBooks', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
    });
};

getThirdParty = (data) => {
  this.getThirdPartyApp(data)
};

setSyncDialogOpen = (value) => {
  this.setState({ syncDialogOpen: value });
};

handleSyncFromQB = () => {
  this.getThirdPartyApp('SyncFromQB');
  this.setSyncDialogOpen(false); 
};

handleSwitchChange = (event) => {
  const checked = event.target.checked;
  this.setState(prevState => {
    let updatedFilter = { ...prevState?.filter };
    if (checked) {
      updatedFilter.individual_invoice = true; 
      this.getFleetInvoicesApi(this.props, { ...updatedFilter, per_page: 50 }, 'pageLoader');
      this.setState({pageSelections:{}})
    } else {
      delete updatedFilter.individual_invoice; 
      this.getFleetInvoicesApi(this.props, { ...updatedFilter, per_page:50}, 'pageLoader');
      this.setState({pageSelections:{}})
    }
    return { filter: updatedFilter };
  })
};
handleSelectAll = (checked, currentPage) => {
  if (checked) {
    const selectableIds = this.state.invoices.list .filter(item => item.invoice_status.value === 2) .map(item => item.id);
    this.setState(prevState => ({ pageSelections: { ...prevState.pageSelections, [currentPage]: selectableIds } }));
  } else {
    this.setState(prevState => ({ pageSelections: { ...prevState.pageSelections, [currentPage]: [] } }));
  }
};

toggleBulkOps = (item, checked, currentPage) => {
  this.setState(prevState => {
    const updated = { ...prevState.pageSelections };
    updated[currentPage] = updated[currentPage] || [];
    if (checked) {
      if (!updated[currentPage].includes(item.id)) {
        updated[currentPage].push(item.id);
      }
    } else {
      updated[currentPage] = updated[currentPage].filter(id => id !== item.id);
    }
    return { pageSelections: updated };
  });
};

getThirdPartyFn = (data) => {
  const selectedItems = data ? data?.invoice_id.split(',') : [];
  if (selectedItems.length > 50) {
    alert("You cannot select more than 50 items.");
    return; 
  }
  this.getThirdPartyAppUrl(data);
}
  exportApprovalReport = () => {
    this.setState({ pageLoader: true });
    globalPostService(`/console/custom-reports/invoice-approval-report/`, { "file_type": "xlsx", })
      .then(response => {
        this.setState({ pageLoader: false });
        if (checkApiStatus(response)) {
          toastFlashMessage(response.data.message, 'success')
        } else {
          toastFlashMessage(response.data.message, 'error')
        }
      })
  }

  render(){
    const { open, skeletonLoader, skeletonLoaderInvType, skeletonLoaderInvStat, skeletonLoaderLesseeType, skeletonLoaderInvLessee,  pageLoader, filter, filterInvoiceType, filterInvoiceStatus, filterLesseeType, filterInvLessee, invoices, sort, sort_by, mode, invoiceTypeGraph, invoiceStatGraph, invoiceLesseeTypeGraphData, invoicelesseeGraphData, lesseeOptions, lessorOptions, ownerOptions, assetModelOptions, assetTypeOptions, assetsOptions, genericFilter, lesseeFilter,tabIndex, bankList,bulkStatusUpdate,invoiceApprovalStatus } = this.state;
    const { pltConstantsLeaseStatus } = this.props;
    let filterOptions = Object.assign({}, invoiceFleetFilterOps);
    filterOptions = {
      ...filterOptions,
      lessee_id: {
        ...filterOptions.lessee_id,
        options: lesseeOptions
      },
      lease_status: {
        ...filterOptions.lease_status,
        options: pltConstantsLeaseStatus
      },
      lessor_id: {
        ...filterOptions.lessor_id,
        options: lessorOptions
      },
      owner_id: {
        ...filterOptions.owner_id,
        options: ownerOptions
      },
      asset_type: {
        ...filterOptions.asset_type,
        options: assetTypeOptions
      },
      asset_model: {
        ...filterOptions.asset_model,
        options: assetModelOptions
      },
      serial_number: {
        ...filterOptions.serial_number,
        options: assetsOptions
      },
      bank:{
        ...filterOptions.bank,
        options:bankList
      }
    }
    let isJac = getLocalStorageInfo().defaultLessor.id === 442 ? true : false
    filterOptions={...filterOptions,...(!isJac?invoiceFilter:{})};
    const selectableIds = this.state.invoices.list.filter(item => item.invoice_status.value === 2).map(item => item.id); 
    const selectedIds = Object.values(this.state.pageSelections || {}).flat(); 
    const ids = selectedIds.join(',');
    return(
      <section className="fleet-lease-management-sec">
        <DeploymentMessage/>
        { isJac && checkPermission('contracts','summary_invoice','R')?
        <Paper style={{marginBottom:'3px'}}>
        <Tabs
            value={tabIndex}
            onChange={(event, newValue) => { this.onChangetabs(newValue)}}
            indicatorColor="primary"
            textColor="primary"
            centered
            variant={'fullWidth'}
          >
             <Tab label="Fleet Invoice" value='1'/>
             <Tab label="Summary Invoice" value='2'/>
        </Tabs>
        </Paper>
        :null}
        {
          tabIndex == '1' && !this.props.location?.search.includes('summary_invoice') ?
          mode == 'list' ?
          <Fragment>
            { skeletonLoader ? <STableLoader count={8} />:
              <Fragment>
                <Paper square style={{padding:'6px 10px'}}>
                  <Grid container spacing={1} alignItems='center'>
                    <Grid item md={jetStreamInstance?3:6}>
                      <FilterComponent 
                        filter={filter}
                        filterMenu={filterOptions}
                        getResponseBack={(applyFilter) => {this.state.fleetInvoiceState == 1? this.getFleetInvoicesApi(this.props, {...applyFilter, page:1, per_page:invoices.pagination.per_page}, 'pageLoader'): this.getApplicableSummaryList({...applyFilter, page:1, per_page:invoices.pagination.per_page})}}
                      />
                    </Grid>
                    <Grid item md={jetStreamInstance?9:6}>
                      {
                        this.state.bulkIds?.length ?
                        <div style={{display:'flex', justifyContent:isJac? 'space-between' : 'right' , alignItems:"center"}}>
                                  { isJac ? <Button onClick={() => {this.generateSumInvoiceApi(this.props, this.state.bulkIds, 'pageLoader');}} color='primary' variant='contained' size='small'>Generate Summary Invoice</Button> : null}
                           <div style={{minWidth:"190px"}}>
                            <Autocomplete
                              disableClearable={true}
                              style={{ marginTop: '4px' }}
                              options={[{ label: 'Sent', value: '2' }]}
                              getOptionLabel={option => option?.label}
                              value={this.state.bulkInvoiceStatus}
                              id="assignment_msn"
                              onChange={(e, value) => this.onBulkInvoiceStatus(e.target.value)}
                              renderInput={params => <TextField style={{ padding: '0px' }} {...params} label="Change Invoice status" placeholder="Draft" InputLabelProps={{ shrink: true }} variant="outlined" />}
                            />
                        </div>
                      </div>:
                      <div style={{ display:'flex', justifyContent:'flex-end' }}>
                      <div style={{ overflowX: 'auto', whiteSpace: 'nowrap'}}>
                      <ul className="list-inline" style={{float:isJac?'':'right', display:'flex', marginBottom:isJac?'4px':""}}>
                        {isJac ?
                          <li className="list-inline-item" >
                            <FormControl style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: 'row'}} >
                            <FormLabel style={{display:'contents'}} >All Invoices<Tooltip title='Includes Summary Invoices'><InfoIcon style={{fontSize:'14px', color:'gray'}}  /></Tooltip></FormLabel>
                                <Switch
                                  checked={filter?.individual_invoice || false}
                                  onChange={this.handleSwitchChange}
                                  color="primary"
                                  size="medium"
                                />
                            <FormLabel >Individual Invoices</FormLabel>
                            </FormControl>
                          </li>
                        : null}
                          {isJac ?
                        <li className="list-inline-item" >
                          <Button size='small' variant="outlined" color='primary' onClick={this.exportApprovalReport}><SaveAltIcon />Approval Report</Button>
                        </li> : null}
                        {isJac ?<>
                        {filter.individual_invoice?
                        <li className="list-inline-item">
                            <Button disabled={!selectedIds.length} color="primary" size="small" variant='outlined' onClick={() => { this.getThirdPartyFn({ invoice_id: ids }); }} > Sync to QB({Object.values(this.state.pageSelections || {}).flat().length}) </Button>
                            <br/>
                            {Object.values(this.state.pageSelections || {}).flat().length > 50 && 
                             ( <div style={{ color: 'red', fontSize: '12px', width:"125px" }}>Cannot sync more than 50 items</div> )
                            }
                        </li>:null}
                        <li className="list-inline-item">
                            <Button size='small' variant="outlined" color='primary' onClick={() =>  {this.setSyncDialogOpen(true)}}>Sync from qb</Button>
                        </li></>:null}
                        <li className="list-inline-item">
                            <Button disabled={(!!filter?.individual_invoice) || !!((hanwahaInstance || jetStreamInstance) && bulkStatusUpdate?.ids?.length) } size='small' variant="outlined" color='primary' onClick={() =>  {this.bulkDownload(filter, bulkStatusUpdate?.ids)}}>Bulk Download</Button>
                            </li>
                        {(!isJac && !invoiceApprovalStatus) && bulkStatusUpdate?.ids.length>0 ?
                        <li className="list-inline-item">
                            <Button size='small' variant='contained' color='primary' onClick={()=> this.setState({bulkStatusUpdate:{...this.state.bulkStatusUpdate,statusModal:true}})}>Change Status({bulkStatusUpdate?.ids.length})</Button>
                        </li>:null}
                        {invoices.list.length > 0 && checkPermission('contracts', 'invoices','EXP') &&
                          <li className="list-inline-item">
                            <ExportManu title="Export" files={[{title:'PDF', extension: 'pdf', key:''},{title:'Excel', extension: 'xls', key:''}, {title:'CSV', extension: 'csv', key:''}]} exportReportFn={(file) => this.exportFleetInvoicesApi(this.props, {...filter, download:file.extension})} />
                          </li>
                        }
                        { checkPermission('contracts', 'invoices','ANA') ?
                          <li className="list-inline-item">
                            <Switcher 
                              mode={mode}
                              onChangeMode={(mode) => this.setState({mode:mode})}
                            />
                          </li>:null
                        }
                      </ul>
                      </div>
                      </div>
                      }
                    </Grid>
                  </Grid>
                </Paper>
                
                <TableListComp
                 heads={[...(jetStreamInstance && filter?.individual_invoice? 
                        [{
                          tableaCellStyle:{position: 'sticky', left: 0, backgroundColor: '#fafafa', zIndex: 10,},
                          label: (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Checkbox
                              color="primary"
                              checked={selectableIds.length > 0 && this.state.pageSelections[this.state.currentPage]?.length === selectableIds.length }
                              onChange={(e) => this.handleSelectAll(e.target.checked, this.state.currentPage)}
                            />
                            <span style={{ fontSize: '8px', marginLeft: '5px' }}>{!selectedIds.length?'Select All':'Unselect All'}</span>
                            </div>
                          )
                        }
                        ] : []),
                          ...(jetStreamInstance ? jacInvoiceFleetHd : invoiceFleetHd)
                      ]}
                  sort={sort}
                  maxheight={isJac ? filter && Object.keys(filter).length > 3 ? window.innerHeight - 250 + 'px' : window.innerHeight - 220 + 'px':filter && Object.keys(filter).length > 3?window.innerHeight - 210 + 'px':''}
                  bulkOperation={(isJac || invoiceApprovalStatus) ? false : true}
                  sort_by={sort_by}
                  bulkFlag={bulkStatusUpdate?.bulkStatus.length===1 && bulkStatusUpdate.ids?.length>0 && bulkStatusUpdate?.ids.length===invoices?.list?.filter(optionItem=> optionItem?.invoice_status?.value===bulkStatusUpdate?.bulkStatus[0]).length}
                  disabled={bulkStatusUpdate?.bulkStatus?.length!==1}
                  toggleBulkOps={(isChecked)=>this.onInvoiceBulkSelect(invoices?.list,isChecked,'bulk')}
                  checkboxStyle={{position: 'sticky', left: 0, backgroundColor: '#fafafa', zIndex: 10,}}
                  data={invoices.list.map((item,index) =>
                    <FleetInvoice
                      bulkIds={this.state.bulkIds}
                      toggleBulkOps={jetStreamInstance?this.toggleBulkOps:this.onInvoiceBulkSelect}
                      individualInvoice={filter?.individual_invoice}
                      pageSelections={this.state.pageSelections}
                      currentPage={this.state.currentPage}
                      index={index}
                      item={item}
                      invoiceApprovalStatus={invoiceApprovalStatus}
                      bulkStatus={this.state.bulkStatusUpdate?.bulkStatus}
                      bulkStatusUpdateIds={this.state.bulkStatusUpdate?.ids} />
                    )
                  }
                  createSortHandler={this.createSortHandler}
                  onChangePage={(event, newPage) => { const page = newPage + 1; this.setState({ currentPage: page }, () => { if (this.state.fleetInvoiceState == 1) { this.getFleetInvoicesApi(this.props, { ...filter, page, per_page: invoices.pagination.per_page, sort, sort_by }, 'pageLoader'); } else { this.getApplicableSummaryList({ ...filter, page, per_page: invoices.pagination.per_page, sort, sort_by })}})}}
                  onChangeRowsPerPage={(event) => {this.state.fleetInvoiceState == 1?  this.getFleetInvoicesApi(this.props, {...filter, page:1, per_page: event.target.value, sort: sort, sort_by: sort_by}, 'pageLoader') : this.getApplicableSummaryList({...filter, page:1, per_page: event.target.value, sort: sort, sort_by: sort_by}) }}
                  pagination={invoices.pagination}
                  noRecord={ invoices.list.length ? null:
                    <EmptyCollection
                      title="No records found"
                    />
                  }
                />
              </Fragment>
            }
          </Fragment> :
          <Fragment>
            <section className="fleet-lease-analytics-sec">
              <Paper className="generic-filter-block">
                <Grid container spacing={1}>
                  <Grid item xs={11} md={11}>
                    <FleetGenericFilter 
                      genericFilter={genericFilter}
                      lesseeOptions={lesseeOptions}
                      lessorOptions={lessorOptions}
                      assetTypeOptions={assetTypeOptions}
                      assetModelOptions={assetModelOptions}
                      assetsOptions={assetsOptions}
                      ownerOptions={ownerOptions}
                      changeGenericFilter={this.changeGenericFilter}
                      processingLoader={skeletonLoaderInvType || skeletonLoaderInvStat || skeletonLoaderLesseeType || skeletonLoaderInvLessee}
                    />
                  </Grid>
                  <Grid item xs={1} md={1}>
                     <ul className='list-inline' style={{float:'right'}}>
                      <li className='list-inline-item'>
                        <Switcher 
                          mode={mode}
                          onChangeMode={(mode) => this.setState({mode:mode})}
                        />
                      </li>
                    </ul>
                  </Grid>
                </Grid>
              </Paper>
              <Grid container spacing={1}>
                <Grid item xs={12} md={6}>
                  <InvoiceTypeGraph 
                    invoiceTypeGraph={invoiceTypeGraph} 
                    skeletonLoader={skeletonLoaderInvType}
                    filter={filterInvoiceType}
                    getResponseBack={(applyFilter)=>this.getInvoiceTypeGraphApi(this.props, genericFilter, applyFilter, 'skeletonLoaderInvType')}
                    callExternalFunction={this.onClickDataPointFn} 
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InvoiceStatusGraph 
                    invoiceStatGraph={invoiceStatGraph} 
                    skeletonLoader={skeletonLoaderInvStat}
                    filter={filterInvoiceStatus}
                    getResponseBack={(applyFilter)=>this.geInvoiceStatusGraphApi(this.props, genericFilter, applyFilter, 'skeletonLoaderInvStat')}
                    callExternalFunction={this.onClickDataPointFn} 
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InvoiceLesseeGraph 
                    invoicelesseeGraphData={invoicelesseeGraphData} 
                    skeletonLoader={skeletonLoaderInvLessee}
                    filter={filterInvLessee}
                    getResponseBack={(applyFilter)=>this.getInvoiceLesseeGraphApi(this.props, genericFilter, applyFilter, 'skeletonLoaderInvLessee')}
                    callExternalFunction={this.onClickDataPointFn} 
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InvoiceLesseeTypeGraph 
                    invoiceLesseeTypeGraphData={invoiceLesseeTypeGraphData} 
                    skeletonLoader={skeletonLoaderLesseeType}
                    filter={filterLesseeType}
                    getResponseBack={(applyFilter)=>this.getLesseeTypeGraphApi(this.props, genericFilter, applyFilter, 'skeletonLoaderLesseeType')}
                    callExternalFunction={this.onClickDataPointFn} 
                  />
                </Grid>
              </Grid>
            </section>
          </Fragment>
          :
          <SummaryInvoice />
        }
        { open ? 
          <Dialog
            open={open}
            anchor="right"
            onClose={() => {this.setState({open:false});this.getFleetInvoicesApi(this.props, {per_page:50}, 'pageLoader');}}
            fullScreen
          >
            <DialogTitle id="form-dialog-title">
              Underlying Data
              <ul className='list-inline' style={{float:'right'}}>
                <li className='list-inline-item'>
                  <ExportManu title="Export" files={[{title:'PDF', extension: 'pdf', key:''},{title:'Excel', extension: 'xls', key:''}, {title:'CSV', extension: 'csv', key:''}]} exportReportFn={(file) => this.exportFleetInvoicesApi(this.props, {...filter, download:file.extension})} />
                </li>
              </ul>
            </DialogTitle>
            <DialogContent dividers={true}>
                <TableListComp
                    heads={invoiceFleetHd}
                    data={invoices.list.map((item,index) =>
                    <FleetInvoice
                        index={index}
                        item={item} />
                    )
                    }
                    pagination={invoices.pagination}
                    onChangePage={(event, newPage) => this.getFleetInvoicesApi(this.props, {...filter, page:newPage+1, per_page:invoices.pagination.per_page, sort: sort, sort_by: sort_by}, 'pageLoader')}
                    onChangeRowsPerPage={(event) => this.getFleetInvoicesApi(this.props, {...filter, page:1, per_page: event.target.value, sort: sort, sort_by: sort_by}, 'pageLoader')}
                    noRecord={ invoices.list.length ? null:
                      <EmptyCollection
                          title="No records found"
                      />
                    }
                />
            </DialogContent>
            <DialogActions style={{paddingLeft:'24px',paddingRight:'24px'}}>
                <Button onClick={() => {this.setState({open:false});this.getFleetInvoicesApi(this.props, {per_page:50}, 'pageLoader');}} color='primary' variant='outlined' size='small'>Close</Button>
            </DialogActions>
          </Dialog>:null    
        }
        <Dialog
          open={this.state.syncDialogOpen}
          maxWidth={'md'}
        >
          <DialogTitle >Sync with QuickBooks</DialogTitle>
          <DialogContent dividers>
            <p>Are you sure you want to Sync Invoice's from QuickBooks to SPARTA ?</p>
            <span>This syncing process will pull the data ('Status') to SPARTA</span>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setSyncDialogOpen(false)} variant='outlined' size='small' color="primary">No</Button>
            <Button onClick={this.handleSyncFromQB} variant='contained' size='small' color="primary">Yes</Button>
            </DialogActions>
        </Dialog>
        {bulkStatusUpdate?.statusModal?
        <BulkStatusChangesDialog
        statusChangeModal={bulkStatusUpdate?.statusModal}
        bulkUpdateIds={bulkStatusUpdate?.ids}
        bulkUpdateStatus={bulkStatusUpdate?.bulkStatus}
        ontoggle={()=>this.setState({bulkStatusUpdate:{...this.state.bulkStatusUpdate,statusModal:false}})}
        getResponseBack={()=> this.getFleetInvoicesApi(this.props, {...filter, page:1, per_page:invoices.pagination.per_page, sort: sort, sort_by: sort_by}, 'pageLoader')}
        />:null}
        { pageLoader ? <PageLoader/>:null }
      </section>
    )
  }
}
const mapStateToProps = state => ({
  pltConstantsLeaseStatus: state.shareReducer.pltConstantsLeaseStatus
})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getPlatformConstantsLeaseStatus: () => dispatch(getPlatformConstantsLeaseStatusAc({constant_types:['lease_status']}))
  }
}
export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(RoleBasedAccess(FleetInvoices, ['contracts','invoices','R'])))
